<template>
  <v-col class="concepts-content">
    <v-row class="mb-4">
      <v-col>
        <h1 class="headline font-weight-bold mb-2">
          Concepts & Glossary
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          outlined
          class="pa-4 mb-3"
        >
          <h2 class="subtitle-2 font-weight-bold mb-2">
            Selected Context
          </h2>
          <p class="body-2 mb-0">
            A search selection that scopes what data and routes show.
          </p>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          outlined
          class="pa-4 mb-3"
        >
          <h2 class="subtitle-2 font-weight-bold mb-2">
            Project Lifecycle
          </h2>
          <p class="body-2 mb-0">
            Status model used to classify projects: active, pending, completed,
            and archived.
          </p>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          outlined
          class="pa-4 mb-3"
        >
          <h2 class="subtitle-2 font-weight-bold mb-2">
            Billing Code
          </h2>
          <p class="body-2 mb-0">
            Primary key used to map organizational and reporting relationships.
          </p>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          outlined
          class="pa-4 mb-3"
        >
          <h2 class="subtitle-2 font-weight-bold mb-2">
            Report
          </h2>
          <p class="body-2 mb-0">
            A delivery or operations view configured for a selected context.
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'ConceptsContent',
}
</script>
